import { anchors } from '@/mocks/mogu-data';

export default function FeaturedAnchors() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            <i className="ri-star-line text-accent-500 mr-2"></i>推荐主播
          </h2>
          <p className="mt-2 text-sm text-foreground-600">发现你喜爱的蘑菇tv主播，关注他们的精彩直播</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {anchors.map((anchor) => (
            <div
              key={anchor.id}
              className="group rounded-xl bg-background-50 p-5 text-center hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="relative mx-auto w-20 h-20 md:w-24 md:h-24">
                <img
                  src={anchor.avatar}
                  alt={anchor.name}
                  className="w-full h-full rounded-full object-cover"
                  loading="lazy"
                />
                {anchor.isLive && (
                  <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse"></span>
                    直播
                  </span>
                )}
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900">{anchor.name}</h3>
              <p className="mt-1 text-xs text-foreground-500">{anchor.description}</p>
              <div className="flex items-center justify-center gap-3 mt-3">
                <span className="text-xs text-foreground-600">
                  <i className="ri-user-heart-line mr-1 text-primary-500"></i>
                  {anchor.followers}粉丝
                </span>
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                  {anchor.category}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}